<template>
  <input-custom v-bind:id="id"
                v-bind:errors="errors"
                v-bind:label="label"
                v-bind:language="language"
                v-bind:required="required"
                v-bind:loading="loading">
    <div v-for="(regions, regionsIndex) in availableRegions" v-bind:key="regionsIndex">
      <select v-bind:value="selectedRegionIds[regionsIndex]" v-on:change="changed" class="form-select mb-3">
        <option v-if="noSelection" v-bind:value="noSelectionValue">{{noSelectionLabel}}</option>
        <option v-for="(region, regionIndex) in regions" v-bind:key="regionIndex" v-bind:value="region.id">{{region.name}}</option>
      </select>
    </div>
  </input-custom>
</template>

<script>
import {regionService} from "@/services/region-service";
export default {
  name: "select-region",
  props: {
    id: {
      type: String,
      required: true
    },
    value: {
      type: [Number, String]
    },
    country: {
      type: [Number, String],
      required: true
    },
    errors: {
      type: Array
    },
    label: {
      type: String
    },
    noSelection: {
      type: Boolean
    },
    noSelectionValue: {
      type: String
    },
    noSelectionLabel: {
      type: String
    },
    language: {
      type: String
    },
    required: {
      type: Boolean
    },
  },
  data: function () {
    return {
      mainRegions: [],
      loading: false,
      loaded: false,
    };
  },
  created: function () {
    this.loadRegions();
  },
  computed: {
    availableRegions: function () {
      var result = [];
      if (this.value) {
        for (var i = 0; i < this.selectedRegions.length; i++) {
          var selected = this.selectedRegions[i];
          if (i == 0) {
            result.push(selected.siblings);
          }
          if (selected.children && selected.children.length) {
            result.push(selected.children);
          }
        }
      }
      if (result.length == 0) {
        result.push(this.mainRegions);
      }
      return result;
    },
    selectedRegions: function () {
      var result = [];
      if (this.value) {
        var region = this.findRegion(this.mainRegions, this.value);
        region: while (region) {
          result.push(region);
          if (region.parents) {
            for (var j = 0; j < region.parents.length; j++) {
              var parent = region.parents[j];
              if (parent.children) {
                for (var k = 0; k < parent.children.length; k++) {
                  var child = parent.children[k];
                  if (region.id == child.id) {
                    region = parent;
                    continue region;
                  }
                }
              }
            }
          }
          break;
        }
        result.reverse();
      }
      return result;
    },
    selectedRegionIds: function () {
        var ids = [];
        for (var i = 0; i < this.selectedRegions.length; i++) {
          ids.push(this.selectedRegions[i].id);
        }
        return ids;
    },
  },
  watch: {
    country: function () {
      this.reset();
      this.loadRegions();
    },
  },
  methods: {
    reset: function () {
      this.mainRegions = [];
      this.loading = false;
      this.loaded = false;
    },
    loadRegions: function () {
      if (!this.loaded && this.country) {
        this.loading = true;
        regionService.loadAll(this.country)
            .then((data) => {
              this.setRegionsWithParentsAndSiblings(null, data);
              this.mainRegions = data;
              if (!data || !this.findRegion(data, this.value)) {
                this.$emit("input", null);
              }
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              this.loading = false;
            });
      }
    },
    setRegionsWithParentsAndSiblings: function (parents, siblings) {
      if (siblings) {
        for (var i = 0; i < siblings.length; i++) {
          var region = siblings[i];
          if (parents) {
            region.parents = parents;
          }
          region.siblings = siblings;
          this.setRegionsWithParentsAndSiblings(siblings, region.children);
        }
      }
    },
    findRegion: function (regions, regionId) {
      if (regions && regionId) {
        for (var i = 0; i < regions.length; i++) {
          var region = regions[i];
          if (region.id == regionId) {
            return region;
          }
          if (region.children) {
            region = this.findRegion(region.children, regionId);
            if (region) {
              return region;
            }
          }
        }
      }
      return null;
    },
    changed: function (event) {
      this.$emit("input", event.target.value);
    },
  },
}
</script>
